var ColorSegmentPoint = (function () {
    function ColorSegmentPoint() {
    }
    return ColorSegmentPoint;
}());
export { ColorSegmentPoint };
